import {Action, State, StateContext, Store} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {tap} from 'rxjs/operators';
import {Section} from "../models";
import {FetchSections} from "./home.actions";
import {HomeService} from "../services/home.service";


export class HomeStateModel {
  public items: Section[];
}


@State<HomeStateModel>({
  name: 'home',
  defaults: {
    items: [],
  }
})
@Injectable()
export class HomeState {

  @Action(FetchSections)
  fetch(ctx: StateContext<HomeStateModel>, action: FetchSections) {
    const state = ctx.getState();

    return this.homeService.fetchSections().pipe(
      tap((response: any) => {

        ctx.patchState({
          items: response as Section[],
        });
      })
    );
  }

  constructor(private homeService: HomeService,
              private store: Store) {
  }

}
